module.exports = __webpack_public_path__ + "static/media/email-country-icon.81f26a7a.svg";